module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAMAAAAocOYLAAAAMFBMVEVMaXFJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZJSEZkeMNTAAAAD3RSTlMAEAPLkf6oY6li1OpmKy8Jrs2RAAAASklEQVR42u3KMRKAIBBD0SwKKCh7/9sCBQXOEBqtME2K99FPbrDJFhNl1SiUrV+Uz69Y6XBN3Ewc5ii3Y7RXAvcHLQhCg8oseHIGC3gKbybAAiMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/ic_jiantou.png
// module id = LepB
// module chunks = 1